import { render } from "./SchedulePrice.vue?vue&type=template&id=eb98e136&scoped=true"
import script from "./SchedulePrice.vue?vue&type=script&lang=js"
export * from "./SchedulePrice.vue?vue&type=script&lang=js"

import "./SchedulePrice.vue?vue&type=style&index=0&id=eb98e136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb98e136"]])

export default __exports__